'use client';

import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { LeftSidebarContent } from './left-sidebar-content';
import { FC, ReactNode } from 'react';

export const LeftSidebarDesktop: FC<{
  menu: ReactNode;
}> = ({ menu }) => {
  const { xl } = useResponsive();
  if (!xl) return null;
  return (
    <aside className="no-scrollbar bg-back600 z-leftSidebar fixed left-0 top-0 hidden h-screen w-[240px] overflow-auto xl:block">
      <LeftSidebarContent className="h-full" menu={menu} />
    </aside>
  );
};
